import { unreachable } from '../../../ts-utils';
export function getCommentCreateError(error) {
    const status = error && 'response' in error && error.response?.status;
    const key = (() => {
        switch (status) {
            case 403:
                return 'toast.error-comment-publish-permission';
            case 429:
                return 'toast.error-comment-publish-throttle';
            case -1:
                return 'toast.error-comment-publish-connection';
            case 413:
            case 400: {
                if ('response' in error &&
                    ((status === 400 && error.response?.data?.message?.includes('size')) ||
                        (status === 413 && error.response?.data?.message?.includes('large')))) {
                    return 'toast.error-content-size-too-large';
                }
                return 'toast.error-comment-publish-generic';
            }
            default:
                return 'toast.error-comment-publish-generic';
        }
    })();
    return {
        type: 'TRANSLATION',
        key,
    };
}
export function getServerError(error) {
    const status = error && 'response' in error && error.response?.status;
    if (typeof status === 'number') {
        return { type: 'SERVER_ERROR', status };
    }
}
export function getCommentCreatePermissionError() {
    return {
        type: 'TRANSLATION',
        key: 'toast.error-comment-publish-permission',
    };
}
export function getGenericError(error) {
    return {
        type: 'TRANSLATION',
        key: (() => {
            const status = error && 'response' in error && error.response?.status;
            switch (status) {
                case 403:
                    return 'toast.error-permission';
                case -1:
                    return 'toast.error-connection';
                default:
                    return 'toast.error-generic';
            }
        })(),
    };
}
export function getGenericPermissionError() {
    return { type: 'TRANSLATION', key: 'toast.error-permission' };
}
export function errorForBi(e) {
    switch (e.type) {
        case 'SILENT':
            return '';
        case 'TRANSLATION':
            return e.key;
        case 'EXTERNAL_TRANSLATION':
            return e.key;
        case 'CUSTOM':
            return e.message;
        default:
            throw unreachable(e);
    }
}
export function interceptorMessageToError(message) {
    return typeof message === 'string' ? { type: 'CUSTOM', message } : message;
}
export const normalizeUnknownExceptionToError = (e) => {
    try {
        return Error(JSON.stringify(e));
    }
    catch {
        // fallback in case there's an error when stringifying error
        return new Error(String(e));
    }
};
//# sourceMappingURL=comments-errors.js.map